import Events from '@utilities/events'
import createElementFromString from '@utilities/dom-utils/create-element-from-string'
import Component from '@utilities/store/lib/component'
import store from '@utilities/store'
import moduleInit from '@utilities/module-init'
import '@utilities/scroll-to'

const JS_HOOK_ACCORDION = 'js-hook-accordion'
const JS_HOOK_RESULTS_COUNT = '[js-hook-store-locator-results-count]'
const JS_HOOK_HOOK_STORE_ID_INPUT = '[js-hook-store-id-input]'
const JS_HOOK_RESULTS_TITLE ='[js-hook-results-title]'
const RESULTS_COUNT_HIDDEN = 'store-locator__result-title--hidden'
const JS_ONLINE_RETAILERS_LIST = '[js-hook-online-retailers-list]'
const HIDDEN_CLASS = 'u-hidden'

class OnlineRetailers extends Component {
  constructor(element) {
    super({
      store,
      element,
    })

    this.resultsTitle = document.querySelector(JS_HOOK_RESULTS_TITLE)
    this.onlineRetailersList = document.querySelector(JS_ONLINE_RETAILERS_LIST)

    this.setUI()
  }

  setUI() {
    this.ui = {
      resultsCount: document.querySelector(JS_HOOK_RESULTS_COUNT),
      storeIdInput: document.querySelector(JS_HOOK_HOOK_STORE_ID_INPUT),
    }
  }

  /**
   * Append the results html in the DOM
   * @param {String} html - html of the results
   */
  appendResults(html) {
    this.element.innerHTML = ''
    this.element.appendChild(html)

    moduleInit.async('[js-hook-accordion]', () =>
      import(/* webpackChunkName: "js/Accordion" */ '@components/accordion'),
    )
    Events.$trigger('events::dom-reinit')

    this.setUI()
  }

  /**
   * Get the results DOM element
   * @param {Array} results - the array of stores results
   * @returns {String} html of the results
   */
  getResults(results) {
    const resultsHtml = document.createElement('div')
    resultsHtml.setAttribute(JS_HOOK_ACCORDION, null)
    let hasOnlineRetailer = false;

    if (results.length > 0) {
      results.forEach((item) => {
        if (item.html && item.isOnline) {
          hasOnlineRetailer = true;
          this.onlineRetailersList.classList.remove(HIDDEN_CLASS)

          const el = createElementFromString(item.html)
          resultsHtml.appendChild(el)
        }
      })
    }

    if(!hasOnlineRetailer) {
      this.onlineRetailersList.classList.add(HIDDEN_CLASS)
    }

    if (this.resultsTitle) {
      this.resultsTitle.classList.remove(RESULTS_COUNT_HIDDEN)
      this.resultsTitle.innerHTML = results.length
    }

    return resultsHtml
  }

  /**
   * render results on right side
   * @param {Array} results - the array of stores results
   */
  render(results) {
    const resultsList = this.getResults(results)

    this.appendResults(resultsList)
  }

  static isReady(state) {
    return state && state.mapsApiReady
  }

  stateChanged() {
    const { state, prevState } = store
    if (!OnlineRetailers.isReady(state)) return
    // Render changes to results list
    const { stores } = state
    if (prevState.stores) {
      this.render(stores)
    }
  }
}

export default OnlineRetailers
